import {IProjectState,IProjectActionTypes,IProjectActionCreator} from 'models/IProjectState';

const initialState:IProjectState[] = []

const reducer = (state = initialState, { type, payload }: IProjectActionCreator) => {
    switch (type) {
      case IProjectActionTypes.FETCH_PROJECT_LIST_REQUEST:
        return {
          ...state,
          data:[],
        }
      case IProjectActionTypes.FETCH_PROJECT_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;